import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import {
  getSupplyOrderDetailAPI,
  getSupplyOrderDetailItemAPI,
  GetSupplyOrderDetailItemResponseType,
  getSupplyOrderTypeAPI,
} from 'features/SupplyOrder/services/outboundSO'
import { callErrorMsg } from 'helpers/errorMsg'

export const SLICE_NAME = 'OUTBOUND_SO_DETAIL'

export const fetchGetSupplyOrderDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSupplyOrderDetail`,
  async (supplyOrderId: number, { rejectWithValue }) => {
    try {
      const response = await getSupplyOrderDetailAPI(supplyOrderId)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetSupplyOrderDetailItem = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSupplyOrderDetailItem`,
  async (
    props: {
      supplyOrderId: number
      params: Partial<{
        pageIndex: number
        pageSize: number
        name: string
      }>
    },
    { rejectWithValue, getState },
  ) => {
    try {
      const {
        outboundSODetail: {
          products: { query },
        },
      } = getState() as StoreStateType

      const { supplyOrderId, params } = props
      const response = await getSupplyOrderDetailItemAPI(supplyOrderId, { ...query, ...params })

      const result: GetSupplyOrderDetailItemResponseType['data'] = {
        content: response.data.data.content,
        pageable: response.data.data.pageable,
        numberOfElements: response.data.data.numberOfElements,
      }

      return result.content
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetSupplyOrderType = createAsyncThunk(
  `${SLICE_NAME}/fetchGetSupplyOrderType`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSupplyOrderTypeAPI()

      return response.data.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
